import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";


//查询列表 GET /factory/findPage
export  const findList =(params)=>{
    return http.get('/factory/findPage',params)
  }

//新增 POST /factory/insertFactory
export function insertFactory(params){
    return http.postJSON("/factory/insertFactory",params);
  }

//编辑 POST /factory/updateFactory
export function update(params){
    return http.postJSON("/factory/updateFactory",params);
  }


// 查询SIM平台客户信息 GET /factory/loadSIMClient
export  const loadSIMClient =()=>{
  return http.get('/factory/loadSIMClient')
}








// WEBPACK FOOTER //
// ./src/services/factory.js